import { render, staticRenderFns } from "./RecaptchaV2Widget.vue?vue&type=template&id=1c452d78&scoped=true&"
import script from "./RecaptchaV2Widget.vue?vue&type=script&lang=ts&"
export * from "./RecaptchaV2Widget.vue?vue&type=script&lang=ts&"
import style0 from "./RecaptchaV2Widget.vue?vue&type=style&index=0&id=1c452d78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c452d78",
  null
  
)

export default component.exports